export const environment = {
    production: false,
    apiUrl: 'https://apiteste.fireblick.com.br',
    apiErpUrl: 'https://erpteste.fireblick.com.br',
    featureFlag: true
  };